import styled from "styled-components";
import LogoFilesComponent from "./LogoFilesComponent";
import LogoSettings from "./LogoSettings";

const DugoutLogoSectionStyle = styled.div.attrs(() => ({
  className: "ml-2 mt-2",
}))``;

const DugoutLogosSection = () => {
  return (
    <DugoutLogoSectionStyle>
      <LogoSettings />
      <LogoFilesComponent />
    </DugoutLogoSectionStyle>
  );
};

export default DugoutLogosSection;
